// extracted by mini-css-extract-plugin
module.exports = {"dotted":"Alert_dotted__Qhrp4"};